import { motion } from 'framer-motion';

const ASSETS = '/images/splash-connect';
const CONNECTIONS = [[20, 57], [80, 57], [12, 77], [88, 77], [29, 91], [71, 91]];
const easeOut = [0.16, 1, 0.3, 1];
// Half-speed movement throughout the storyboard, not just a longer logo hold.
const slow = seconds => seconds * 2;
export const CONNECT_LOGO_FADE_SECONDS = 1.2;

export const ConnectSplashScene = ({ phase, reducedMotion, onAssetError }) => {
  const resolved = ['logo', 'revealing'].includes(phase);
  return <div className="connect-splash-scene" data-testid="splash-storyboard-scene" aria-hidden="true">
    {!reducedMotion && <motion.div className="connect-splash-action" data-testid="splash-action-layer"
      initial={{ opacity: 1 }} animate={{ opacity: resolved ? 0 : 1 }} transition={{ duration: CONNECT_LOGO_FADE_SECONDS, ease: 'easeInOut' }}>
      <motion.div className="connect-splash-flight" data-testid="splash-eagle-flight"
        initial={{ x: '-65%', y: '-24%', rotate: -13, scale: .78 }}
        animate={{ x: ['-65%', '0%', '0%'], y: ['-24%', '0%', '0%'], rotate: [-13, 0, 0], scale: [.78, 1, 1] }}
        transition={{ duration: slow(.64), times: [0, .82, 1], ease: easeOut }}>
        <motion.img src={`${ASSETS}/eagle.webp`} alt="" className="connect-splash-eagle" data-testid="splash-eagle-image"
          fetchPriority="high" decoding="async" draggable={false} onError={onAssetError}
          initial={{ y: 0 }} animate={{ y: [0, 0, '-4%', '0%'] }}
          transition={{ duration: slow(1.85), times: [0, .34, .66, 1], ease: 'easeInOut' }} />
        <motion.img src={`${ASSETS}/ball.webp`} alt="" className="connect-splash-ball" data-testid="splash-ball-image"
          fetchPriority="high" decoding="async" draggable={false} onError={onAssetError}
          initial={{ y: '0%', scaleY: 1 }}
          animate={{ y: ['0%', '0%', '130%', '85%', '130%', '130%'], scaleY: [1, 1, .88, 1, .94, 1] }}
          transition={{ duration: slow(1.75), times: [0, .343, .571, .671, .771, 1], ease: 'easeInOut' }} />
      </motion.div>
      {[0, 1].map(index => <motion.div key={index} className="connect-splash-pulse" data-testid={`splash-pulse-${index + 1}`}
        initial={{ opacity: 0, scale: .12 }} animate={{ opacity: [0, .8, 0], scale: [.12, .6, 1.15] }}
        transition={{ delay: slow(1 + index * .16), duration: slow(.7), times: [0, .2, 1], ease: 'easeOut' }} />)}
      {CONNECTIONS.map(([x, y], index) => {
        const dx = x - 50, dy = y - 80;
        return <div key={index} className="connect-splash-connection" data-testid={`splash-connection-${index + 1}`}>
          <div className="connect-splash-line-position" style={{ width: `${Math.hypot(dx, dy)}%`, transform: `rotate(${Math.atan2(dy, dx)}rad)` }}>
            <motion.span className="connect-splash-line" initial={{ scaleX: 0, opacity: 0 }} animate={{ scaleX: 1, opacity: .65 }}
              transition={{ delay: slow(1.25 + index * .055), duration: slow(.28) }} />
          </div>
          <div className="connect-splash-golfer-position" style={{ left: `${x}%`, top: `${y}%` }}>
            <motion.img src={`${ASSETS}/golfer.webp`} alt="" className="connect-splash-golfer" data-testid={`splash-golfer-${index + 1}`}
              decoding="async" draggable={false} onError={onAssetError}
              initial={{ opacity: 0, scale: .5 }} animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: slow(1.3 + index * .055), duration: slow(.25), ease: easeOut }} />
          </div>
        </div>;
      })}
    </motion.div>}
    <motion.img src={`${ASSETS}/logo.webp`} alt="Par Seeker Connect" className="startup-splash-logo"
      data-testid="logo-splash-image" fetchPriority="high" decoding="async" draggable={false} onError={onAssetError}
      initial={{ opacity: reducedMotion ? 1 : 0, scale: reducedMotion ? 1 : .93 }}
      animate={{ opacity: reducedMotion || resolved ? 1 : 0, scale: reducedMotion || resolved ? 1 : .93 }}
      transition={{ duration: reducedMotion ? 0 : CONNECT_LOGO_FADE_SECONDS, ease: 'easeInOut' }} />
  </div>;
};